/**
 * useBreakpoint — тонкая обёртка над `Grid.useBreakpoint()` из antd.
 * Отдаёт семантические булевы вместо `{xs, sm, md, lg, ...}`.
 *
 *  - isMobile:  < md   (<768)    → телефоны
 *  - isTablet:  < lg   (<992)    → телефоны + планшеты
 *  - isDesktop: ≥ lg   (≥992)    → ноуты/мониторы
 */

import {Grid} from 'antd';

export type UseBreakpointResult = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

export const useBreakpoint = (): UseBreakpointResult => {
  const screens = Grid.useBreakpoint();

  const isMobile = !screens.md;
  const isTablet = !screens.lg;
  const isDesktop = !!screens.lg;

  return {isMobile, isTablet, isDesktop};
};
